import {
  APIError,
  completeAssetUpload,
  prepareAssetUpload,
} from './api';
import { database, type LocalAssetEntry } from './database';

export async function uploadPendingAssets(userId: string) {
  const now = Date.now();
  const pending = (await database.assets.where('[userId+status]').equals([userId, 'pending']).toArray())
    .filter(asset => !asset.nextAttemptAt || Date.parse(asset.nextAttemptAt) <= now)
    .slice(0, 4);
  for (const asset of pending) await uploadAsset(asset);
}

async function uploadAsset(asset: LocalAssetEntry) {
  await database.assets.update(asset.key, { status: 'uploading', updatedAt: new Date().toISOString() });
  try {
    const intent = await prepareAssetUpload({
      assetId: asset.assetId,
      entityType: asset.entityType,
      entityId: asset.entityId,
      kind: asset.kind,
      mediaType: asset.mediaType,
      byteCount: asset.byteCount,
      checksumSha256: asset.checksumSha256,
    });
    const response = await fetch(intent.upload.url, {
      method: intent.upload.method,
      headers: intent.upload.headers,
      body: asset.data,
    });
    if (!response.ok) throw new Error(`对象存储拒绝了资源上传（${response.status}）`);
    const completed = await completeAssetUpload(asset.assetId);
    if (completed.asset.status !== 'ready') throw new Error('资源完整性校验尚未通过');
    await database.assets.update(asset.key, {
      status: 'ready',
      retryCount: asset.retryCount,
      nextAttemptAt: undefined,
      lastError: undefined,
      updatedAt: new Date().toISOString(),
    });
  } catch (error) {
    const permanent = error instanceof APIError && [402, 413].includes(error.status);
    const retryCount = asset.retryCount + 1;
    await database.assets.update(asset.key, {
      status: permanent ? 'failed' : 'pending',
      retryCount,
      nextAttemptAt: permanent ? undefined : new Date(Date.now() + Math.min(60_000, 2 ** retryCount * 2_000)).toISOString(),
      lastError: error instanceof Error ? error.message : '资源上传失败',
      updatedAt: new Date().toISOString(),
    });
  }
}
